import type { HumanMessage, Message } from '@/features/ai-chat/types/chat.types';

export default function isHumanMessage(message: Message | undefined): message is HumanMessage {
  return message?.sender === 'human';
}
